import { decode } from 'html-entities';
import DOMPurify from 'dompurify';

export const normalizeHabitName = (input?: string) => {
  const raw = typeof input === 'string' ? input : '';
  const withoutTags = DOMPurify.sanitize(raw, {
    ALLOWED_TAGS: [],
    ALLOWED_ATTR: []
  });
  const decoded = decode(withoutTags);
  // Remove format characters (bidi, etc.)
  const withoutFormat = decoded.replace(/[\p{Cf}]/gu, '');
  // Replace all control characters (Unicode category Cc) with a space, then collapse
  const controlCharsPattern = new RegExp('\\p{Cc}', 'gu');
  const withoutControl = withoutFormat.replace(controlCharsPattern, ' ');
  const normalizedName = withoutControl.replace(/\s+/g, ' ').trim();
  return normalizedName;
};
